package net.frozenbit.games.soundgame.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.drawWithCache
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.StrokeCap
import androidx.compose.ui.graphics.drawscope.Stroke
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import net.frozenbit.games.soundgame.theme.Colors
import net.frozenbit.games.soundgame.theme.Typography
import net.frozenbit.games.soundgame.ui.utils.animateTimeProgress
import net.frozenbit.games.soundgame.utils.Countdown

@Composable
fun CountdownTimer(
    tick: Countdown.Tick,
    modifier: Modifier = Modifier,
) {
    val progress = animateTimeProgress(tick.startTime, tick.endTime)

    Box(
        modifier = modifier
            .size(72.dp)
            .background(
                color = Colors.Host.containerBackground,
                shape = CircleShape,
            )
            .drawWithCache {
                onDrawBehind {
                    val strokeWidth = 8.dp.toPx()
                    val radius = (size.minDimension / 2) - (strokeWidth / 2)
                    val center = Offset(size.width / 2, size.height / 2)
                    val sweepAngle = 360f * (1f - progress.value)
                    drawArc(
                        color = Colors.Host.primary,
                        startAngle = -90f,
                        sweepAngle = sweepAngle,
                        useCenter = false,
                        topLeft = Offset(center.x - radius, center.y - radius),
                        size = Size(radius * 2, radius * 2),
                        style = Stroke(width = strokeWidth, cap = StrokeCap.Round)
                    )
                }
            },
        contentAlignment = Alignment.Center,
    ) {
        Text(
            text = tick.text,
            fontFamily = Typography.courierPrime(),
            fontSize = Typography.Host.bodySize,
            textAlign = TextAlign.Center,
        )
    }
}